import React from 'react';

import classnames from 'classnames';

import { EVENTS_URL, EVENT_DETAIL_URL } from 'global-constants';

import WithPush from 'shared/HOCs/WithPush';

import { substituteUrl } from 'shared/utils/substituteUrl';

import Event from 'shared/components/Event';
import Loader from 'shared/components/Loader';
import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const FeaturedEvents = ({ push, events, isFetching }) => (
  <div className={classnames(styles.container, 'container')}>
    <div className={styles.title}>Upcoming Events</div>
    {isFetching ? (
      <Loader />
    ) : (
      events.map(event => (
        <Event
          key={`featured-event-${event.id}`}
          event={event}
          className={styles.event}
          onClick={() =>
            push(
              substituteUrl(EVENT_DETAIL_URL, {
                eventSlug: event.slug
              })
            )
          }
        />
      ))
    )}
    <Button
      color="primary"
      onClick={() => push(EVENTS_URL)}
      className={styles.button}>
      View all Events
    </Button>
  </div>
);

export default WithPush(FeaturedEvents);
